// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--3mpYk";
export var btn_icon = "styles-module--btn_icon--liye1";
export var dark = "styles-module--dark--2eohK";
export var white = "styles-module--white--2RWGK";